import { Vector2, Mesh, PlaneBufferGeometry, ShaderMaterial } from 'three'
import Block from './Block'
import App from '../App'
import gsap from 'gsap'
import vertexShader from '../shader/bubble.vert'
import fragmentShader from '../shader/bubble.frag'
import fragmentHomeShader from '../shader/bubbleHome.frag'
import WebglScene from '../util/WebglScene'

export default class Bubbles extends Block {
  onEnterCompleted() {
    super.onEnterCompleted()

    this.isHome = this.el.parentElement.classList.contains('home')
    if (App.GPU.tier === 'GPU_DESKTOP_TIER_0') this.el.classList.add('show-images')
    else {
      this.webglReady = false
      this.webglContext = new WebglScene(this.planeElement)
      this.sizes = new Vector2(0, 0)
      this.offset = new Vector2(0, 0)

      this.getBounds()
      this.createMesh()
      this.showPlane()
    }
  }

  getBounds() {
    this.planeElementRect = this.planeElement.getBoundingClientRect()

    const { width, height, left, top } = this.planeElementRect

    if (!this.sizes.equals(new Vector2(width, height))) {
      this.sizes.set(width, height)
    }

    if (!this.offset.equals(new Vector2(left - window.innerWidth / 2 + width / 2, -top + window.innerHeight / 2 - height / 2))) {
      this.offset.set(left - window.innerWidth / 2 + width / 2, -top + window.innerHeight / 2 - height / 2)
    }
  }

  showPlane() {
    gsap.to(this.mesh.material.uniforms.u_alpha, {
      duration: 0.6,
      ease: 'power2.out',
      value: 1.0
    })
  }

  getElems() {
    this.planeElement = this.el.querySelector('.plane')
  }

  createMesh() {
    this.geometry = new PlaneBufferGeometry(1, 1, 1, 1)
    this.material = new ShaderMaterial({
      uniforms: {
        u_resolution: { value: [this.planeElement.offsetWidth, this.planeElement.offsetHeight] },
        u_amount: { value: 0.0 },
        u_alpha: { value: 0.0 },
        u_time: { value: 0.0 },
        u_background: { value: 1.0 },
        u_moveprogress: { value: 0.0 },
        u_coefblue: { value: 0.7 },
        u_coefviolet: { value: 0.8 },
        u_gpucoef: { value: ['GPU_DESKTOP_TIER_2', 'GPU_DESKTOP_TIER_3'].indexOf(App.GPU.tier) > -1 ? 1.0 : 0.0 }
      },
      vertexShader,
      fragmentShader: this.isHome ? fragmentHomeShader : fragmentShader
    })

    this.mesh = new Mesh(this.geometry, this.material)
    this.mesh.position.set(this.offset.x, this.offset.y, 0)
    this.mesh.scale.set(this.sizes.x, this.sizes.y, 1)
    this.webglContext.scene.add(this.mesh)
    App.plane = this.mesh
  }

  update() {
    if (!this.mesh || !this.webglContext) return

    this.mesh.material.uniforms.u_amount.value += 1
    this.mesh.material.uniforms.u_time.value += 1

    this.webglContext.render()
  }

  resize() {
    if (!this.mesh) return

    this.webglContext.resize()

    this.getBounds()

    this.mesh.position.set(this.offset.x, this.offset.y, 0)
    this.mesh.scale.set(this.sizes.x, this.sizes.y, 1)
  }

  scroll() {
    if (!App.smoothScroll.scroll || !this.mesh) return

    gsap.to(this.mesh.material.uniforms.u_moveprogress, {
      value: App.currentScroll / App.smoothScroll.scroll.instance.limit,
      duration: 0.4,
      ease: 'power2.out'
    })
  }

  destroy() {
    App.plane = null
    this.webglContext.destroy()
    this.webglContext = null
  }
}



// WEBPACK FOOTER //
// ./scripts/blocks/Bubbles.js